function n(n,r){return t=>t>0?r:n}export{n as mixImmediate};
